import React from 'react';
import {
  Chart as ChartJS,
  Tooltip,
  Legend,
  ArcElement
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Box, Heading } from "@chakra-ui/react";
import CustomCard from "../ui/card";

ChartJS.register(ArcElement, Tooltip, Legend);

const data = {
  labels: ['America', 'Asia', 'Africa', 'Europe'],
  // labels: [],
  datasets: [
    {
      label: '# of visits',
      data: [12, 19, 3, 5],
      backgroundColor: [
        'rgba(255, 72, 67, 1)',
        'rgba(241, 182, 9, 1)',
        'rgba(33, 101, 209, 1)',
        'rgba(25, 144, 255, 1)',
      ],
      borderColor: [
        'rgba(255, 72, 67, 1)',
        'rgba(241, 182, 9, 1)',
        'rgba(33, 101, 209, 1)',
        'rgba(25, 144, 255, 1)',
      ],
      borderWidth: 1,
    },
  ],
};

export function WebsiteVisits({ className }: { className?: string }) {
  return (
    <CustomCard
      width='100%'
      children={(
        <>
          <Heading as='h4' size='md' marginBottom='2'>Website traffic by country</Heading>
          <Box className={className} width='100%'>
            <Pie data={data} width='100%' height='100%' />
          </Box>
        </>
      )} 
      />
  );
}
